import type { QueryClient } from '@tanstack/react-query';
import { retireCleanQuoteDrafts } from './draft-store.ts';

/**
 * Drop every cached quote view so the Scheduled badge is read again.
 *
 * The badge is not a stored status. An accepted quote reads Scheduled while
 * a live series still claims it, and Accepted again once that series ends.
 * The list, the editor, and the customer's quote tab each keep their own
 * query. Invalidating one does not touch the others: a prefix of `quotes`
 * does not match `quote` or `customer-quotes`.
 */
export function invalidateQuoteViews(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ['quotes'] });
  void queryClient.invalidateQueries({ queryKey: ['quote'] });
  void queryClient.invalidateQueries({ queryKey: ['customer-quotes'] });
  // What a quote's payments card and job card offer depends on its status,
  // and the Booked list on which quotes are still booked.
  void queryClient.invalidateQueries({ queryKey: ['quote-payments'] });
  void queryClient.invalidateQueries({ queryKey: ['single-job'] });
  void queryClient.invalidateQueries({ queryKey: ['booked-jobs'] });
  // What is owed counts an accepted quote until it is booked or settled, so a
  // booking, or a schedule ending, moves it on the dashboard and the customer.
  void queryClient.invalidateQueries({ queryKey: ['owed'] });
  void retireCleanQuoteDrafts();
}
